import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Avatar,
  Box,
  Card,
  CardHeader,
  Flex,
  Heading,
  Text,
  Image,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineMail,
  AiOutlineInfoCircle,
} from "react-icons/ai";
import { BsListTask, BsFingerprint, BsChatDots } from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import { TbMathGreater } from "react-icons/tb";

import companylogo from "../assets/companylogo.png";
import { fetchAttendances, getUsers } from "../Redux/app/action";
const Sidebar = () => {
  const globalState = useSelector((store) => store.authentication.data.token);
  //console.log("sidebar gs",globalState)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);
  const id = useSelector((store) => store.authentication.users.id);

  const users = useSelector((store) => store.AppReducer.users);
  const filteredUser = users?.filter((obj) => obj._id === id) || [];
  //console.log("image", filteredUser[0])
  const location = useLocation();

  const isActive = (pathname) => {
    return location.pathname === pathname;
  };

  useEffect(() => {
    dispatch(fetchAttendances());
  }, [dispatch]);
  const attendances = useSelector((state) => state.AppReducer.attendances);
  const empglobalState = useSelector((store) => store.authentication.users.id);
  const filteredData =
    attendances?.filter((obj) => obj.employee_id === empglobalState) || [];

  const reversedAttendances = [...filteredData].reverse();
  const attendance = reversedAttendances.find(
    (attendance) => attendance.employee_id === id
  );
  const getStatusColor = (status) => {
    return status === "Available" ? "green" : "red";
  };
  const statusColor = attendance ? getStatusColor(attendance.status) : "gray";

  return (
    <Box p={{ base: "none", md: 5 }} w={{ base: "100%", md: "15%" }}>
      <Box display={{ base: "none", sm: "block" }}>
        <Link to="/employee">
          <Box w={150}>
            <Image
              src={companylogo}
              width={{ base: "50%", sm: "50%", md: "50%" }} // Adjust width for different breakpoints
              height="auto"
              objectFit="cover"
            />
          </Box>
        </Link>
        <br />
        <Link to="/employeedetails">
          <Card maxW="md" backgroundColor={"teal.100"}>
            <CardHeader>
              <Flex spacing="4">
                <Flex
                  gap="3"
                  alignItems="center"
                  flexWrap="wrap"
                  textAlign={"start"}
                >
                  {/* <Avatar
                    name={globalState.first_name}
                    src={`https://project360-backend.onrender.com/${filteredUser[0].path}`}
                  /> */}
                  <Box
                    style={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    <Avatar
                      name={globalState.first_name}
                      size="sm"
                      src={
                        filteredUser[0]
                          ? `https://project360-backend.onrender.com/${filteredUser[0].path}`
                          : `https://project360-backend.onrender.com/${globalState.path}`
                      }
                    />

                    <span
                      style={{
                        position: "absolute",
                        bottom: "-2px", // Adjust this value to position the status dot properly
                        right: "-2px", // Adjust this value to position the status dot properly
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: statusColor,
                      }}
                    />
                  </Box>

                  <Box>
                    <Heading size="sm">
                      {globalState.first_name} {globalState.last_name}
                    </Heading>
                    <Text textTransform={"capitalize"}>{globalState.designation}</Text>
                  </Box>
                </Flex>
              </Flex>
            </CardHeader>
          </Card>
        </Link>
        <br />
        <br />
        <Heading size="md" fontWeight={"bold"} textAlign={"start"}>
          General
        </Heading>
        <br />
        <Accordion allowToggle lineHeight={8}>
          <Link to="/employee">
            <AccordionItem>
              <h2>
                <AccordionButton
                  // _hover={{ fontWeight: "semibold", color: "green" }}
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/employee") ? "green" : "green",
                  }}
                  color={isActive("/employee") ? "green" : "inherit"}
                >
                  <AiOutlineHome />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Dashboard
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <Link to="/task">
            <AccordionItem>
              <h2>
                <AccordionButton
                  // _hover={{ fontWeight: "semibold", color: "green" }}
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/task") ? "green" : "green",
                  }}
                  color={isActive("/task") ? "green" : "inherit"}
                >
                  <BsListTask />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Task
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <Link to="/attendence">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/attendence") ? "green" : "green",
                  }}
                  color={isActive("/attendence") ? "green" : "inherit"}
                >
                  <BsFingerprint />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Attendence
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <Link to="/chat">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/chat") ? "green" : "green",
                  }}
                  color={isActive("/chat") ? "green" : "inherit"}
                >
                  <BsChatDots />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Chats
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <Link to="/calender">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/calender") ? "green" : "green",
                  }}
                  color={isActive("/calender") ? "green" : "inherit"}
                >
                  <SlCalender />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Calender
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <Link to="/generateletters">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/generateletters") ? "green" : "green",
                  }}
                  color={isActive("/generateletters") ? "green" : "inherit"}
                >
                  <AiOutlineMail />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Generate Letters
                  </Box>
                  <TbMathGreater />
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <Link to="/exit">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/exit") ? "green" : "green",
                  }}
                  color={isActive("/exit") ? "green" : "inherit"}
                >
                  <AiOutlineInfoCircle />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Exit Management
                  </Box>
                  <TbMathGreater />
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
        </Accordion>
      </Box>
    </Box>
  );
};

export default Sidebar;
